module.exports = __webpack_public_path__ + "static/563c8b9b0fb5bd192bb632f1d851fd6d-27fbc9e5ba379ce5879e3a3c0831c5e6.woff";